import Papa from 'papaparse'
import GeoJSON from 'geojson'

export async function getcsvdata(url) {
  const parsePromise = url => {
    return new Promise((resolve, reject) => {
      try {
        Papa.parse(url, {
          download: true,
          header: true,
          complete: results => {
            resolve(results.data)
          }
        })
      } catch (error) {
        reject(error)
      }
    })
  }

  const parseResult = await parsePromise(url)
  return parseResult.map((item, id) => ({ ...item, id }))
}

export function toGeoJSON(
  dataArray,
  config = { Point: ['Latitude', 'Longitude'] }
) {
  const valideDataArray = dataArray.filter(i => i.Latitude && i.Longitude)
  return GeoJSON.parse(valideDataArray, config)
}
